var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 1c-6.0751625 0-11 4.9248375-11 11s4.9248375 11 11 11 11-4.9248375 11-11-4.9248375-11-11-11zm5.30805 8.97471667-5.8666667 5.86666663c-.2506166.2506625-.5800666.3752834-.90805.3752834-.3279833 0-.6574333-.1246209-.90804997-.3752834l-2.93333333-2.9333333c-.49990417-.5012792-.49990417-1.3148208 0-1.8161.50127917-.501325 1.31482083-.501325 1.8161 0l2.0252833 2.0266583 4.9586167-4.95999163c.5012792-.501325 1.3148208-.501325 1.8161 0 .4999042.50127916.4999042 1.31482083 0 1.8161z",
    fill: "#0f7940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenTick);
export default __webpack_public_path__ + "static/media/icon-green-tick.214cc510.svg";
export { ForwardRef as ReactComponent };